import * as React from 'react';
import { PropsWithChildren } from 'react';

import { UitkHeading } from 'uitk-react-text';

function Title({ children }: PropsWithChildren<unknown>): JSX.Element {
  return (
    <header className="title">
      <UitkHeading tag="h1" className="title__heading" size={3}>
        {children}
      </UitkHeading>
    </header>
  );
}

export { Title };
